// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Int from "@rescript/core/src/Core__Int.bs.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as ErrorUtils$OrcaPaymentPage from "./ErrorUtils.bs.js";
import * as BrowserSpec$OrcaPaymentPage from "../BrowserSpec.bs.js";
import * as EnglishLocale$OrcaPaymentPage from "../LocaleStrings/EnglishLocale.bs.js";
import * as PaymentMethodCollectTypes$OrcaPaymentPage from "../Types/PaymentMethodCollectTypes.bs.js";

function getNestedValue(dict, key) {
  let keys = key.split(".");
  let length = keys.length;
  let _currentDict = dict;
  let _index = 0;
  while (true) {
    let index = _index;
    let currentDict = _currentDict;
    if (index === (length - 1 | 0)) {
      return currentDict[keys[index]];
    }
    let keyPart = keys[index];
    let subDict = currentDict[keyPart];
    if (subDict === undefined) {
      return;
    }
    let innerDict = Core__JSON.Decode.object(subDict);
    if (innerDict === undefined) {
      return;
    }
    _index = index + 1 | 0;
    _currentDict = innerDict;
    continue;
  };
}

function getOrCreateSubDict(dict, key) {
  let subDict = dict[key];
  if (subDict !== undefined) {
    let innerDict = Core__JSON.Decode.object(subDict);
    if (innerDict !== undefined) {
      return innerDict;
    }
    let newSubDict = {};
    dict[key] = newSubDict;
    return newSubDict;
  }
  let newSubDict$1 = {};
  dict[key] = newSubDict$1;
  return newSubDict$1;
}

function setNestedValue(dict, key, value) {
  let keys = key.split(".");
  let _currentDict = dict;
  let _index = 0;
  while (true) {
    let index = _index;
    let currentDict = _currentDict;
    if (index === (keys.length - 1 | 0)) {
      currentDict[keys[index]] = value;
      return;
    }
    let keyPart = keys[index];
    let subDict = getOrCreateSubDict(currentDict, keyPart);
    _index = index + 1 | 0;
    _currentDict = subDict;
    continue;
  };
}

function getPaymentMethodForPmt(paymentMethodType) {
  switch (paymentMethodType.TAG) {
    case "Card" :
      return "Card";
    case "BankRedirect" :
      return "BankRedirect";
    case "BankTransfer" :
      return "BankTransfer";
    case "Wallet" :
      return "Wallet";
  }
}

function getPaymentMethod(paymentMethod) {
  switch (paymentMethod) {
    case "Card" :
      return "card";
    case "BankRedirect" :
      return "bank_redirect";
    case "BankTransfer" :
      return "bank_transfer";
    case "Wallet" :
      return "wallet";
  }
}

function getPaymentMethodForPayoutsConfirm(paymentMethod) {
  switch (paymentMethod) {
    case "Card" :
      return "card";
    case "BankRedirect" :
      return "bank_redirect";
    case "BankTransfer" :
      return "bank";
    case "Wallet" :
      return "wallet";
  }
}

function getPaymentMethodType(paymentMethodType) {
  switch (paymentMethodType.TAG) {
    case "Card" :
      if (paymentMethodType._0 === "Credit") {
        return "credit";
      } else {
        return "debit";
      }
    case "BankRedirect" :
      return "interac";
    case "BankTransfer" :
      switch (paymentMethodType._0) {
        case "ACH" :
          return "ach";
        case "Bacs" :
          return "bacs";
        case "Pix" :
          return "pix";
        case "Sepa" :
          return "sepa_bank_transfer";
      }
    case "Wallet" :
      if (paymentMethodType._0 === "Paypal") {
        return "paypal";
      } else {
        return "venmo";
      }
  }
}

function getPaymentMethodLabel(paymentMethod) {
  switch (paymentMethod) {
    case "Card" :
      return "Card";
    case "BankRedirect" :
    case "BankTransfer" :
      return "Bank";
    case "Wallet" :
      return "Wallet";
  }
}

function getPaymentMethodTypeLabel(paymentMethodType) {
  switch (paymentMethodType.TAG) {
    case "Card" :
      return "Card";
    case "BankRedirect" :
      return "Interac";
    case "BankTransfer" :
      switch (paymentMethodType._0) {
        case "ACH" :
          return "ACH";
        case "Bacs" :
          return "BACS";
        case "Pix" :
          return "Pix";
        case "Sepa" :
          return "SEPA";
      }
    case "Wallet" :
      if (paymentMethodType._0 === "Paypal") {
        return "PayPal";
      } else {
        return "Venmo";
      }
  }
}

function getPaymentMethodDataFieldKey(key) {
  if (key.TAG === "BillingAddress") {
    let tmp = key._0;
    if (typeof tmp === "object") {
      if (tmp.TAG === "FullName") {
        return "billing.address.fullName";
      } else {
        return "billing.address.addressCountry";
      }
    }
    switch (tmp) {
      case "Email" :
        return "billing.address.email";
      case "CountryCode" :
        return "billing.address.countryCode";
      case "PhoneNumber" :
        return "billing.address.phoneNumber";
      case "PhoneCountryCode" :
        return "billing.address.phoneCountryCode";
      case "AddressLine1" :
        return "billing.address.addressLine1";
      case "AddressLine2" :
        return "billing.address.addressLine2";
      case "AddressCity" :
        return "billing.address.addressCity";
      case "AddressState" :
        return "billing.address.addressState";
      case "AddressPincode" :
        return "billing.address.addressPincode";
    }
  } else {
    let tmp$1 = key._0;
    if (typeof tmp$1 === "object") {
      return "card.cardExp";
    }
    switch (tmp$1) {
      case "CardNumber" :
        return "card.cardNumber";
      case "CardHolderName" :
        return "card.cardHolder";
      case "CardBrand" :
        return "card.brand";
      case "ACHRoutingNumber" :
        return "ach.routing";
      case "ACHAccountNumber" :
        return "ach.account";
      case "ACHBankName" :
        return "ach.bankName";
      case "ACHBankCity" :
        return "ach.bankCity";
      case "BacsSortCode" :
        return "bacs.sort";
      case "BacsAccountNumber" :
        return "bacs.account";
      case "BacsBankName" :
        return "bacs.bankName";
      case "BacsBankCity" :
        return "bacs.bankCity";
      case "SepaIban" :
        return "sepa.iban";
      case "SepaBic" :
        return "sepa.bic";
      case "SepaBankName" :
        return "sepa.bankName";
      case "SepaBankCity" :
        return "sepa.bankCity";
      case "SepaCountryCode" :
        return "sepa.countryCode";
      case "PaypalMail" :
        return "paypal.email";
      case "PaypalMobNumber" :
        return "paypal.phoneNumber";
      case "PixKey" :
        return "pix.key";
      case "PixBankAccountNumber" :
        return "pix.account";
      case "PixBankName" :
        return "pix.bankName";
      case "VenmoMobNumber" :
        return "venmo.phoneNumber";
      case "InteracEmail" :
        return "interac.email";
    }
  }
}

function getPaymentMethodDataFieldLabel(key, localeString) {
  if (key.TAG === "BillingAddress") {
    let tmp = key._0;
    if (typeof tmp === "object") {
      if (tmp.TAG === "FullName") {
        return localeString.fullNameLabel;
      } else {
        return localeString.countryLabel;
      }
    }
    switch (tmp) {
      case "Email" :
        return localeString.emailLabel;
      case "PhoneNumber" :
        return localeString.formFieldPhoneNumberLabel;
      case "CountryCode" :
      case "PhoneCountryCode" :
        return localeString.formFieldCountryCodeRequiredLabel;
      case "AddressLine1" :
        return localeString.line1Label;
      case "AddressLine2" :
        return localeString.line2Label;
      case "AddressCity" :
        return localeString.cityLabel;
      case "AddressState" :
        return localeString.stateLabel;
      case "AddressPincode" :
        return localeString.postalCodeLabel;
    }
  } else {
    let tmp$1 = key._0;
    if (typeof tmp$1 === "object") {
      return localeString.validThruText;
    }
    switch (tmp$1) {
      case "CardNumber" :
        return localeString.cardNumberLabel;
      case "CardHolderName" :
        return localeString.cardHolderName;
      case "CardBrand" :
        return "Misc.";
      case "ACHRoutingNumber" :
        return localeString.formFieldACHRoutingNumberLabel;
      case "BacsSortCode" :
        return localeString.sortCodeText;
      case "ACHAccountNumber" :
      case "BacsAccountNumber" :
        return localeString.accountNumberText;
      case "SepaIban" :
        return localeString.formFieldSepaIbanLabel;
      case "SepaBic" :
        return localeString.formFieldSepaBicLabel;
      case "ACHBankCity" :
      case "BacsBankCity" :
      case "SepaBankCity" :
        return localeString.formFieldBankCityLabel;
      case "SepaCountryCode" :
        return localeString.formFieldCountryCodeLabel;
      case "PixKey" :
        return localeString.formFieldPixIdLabel;
      case "PixBankAccountNumber" :
        return localeString.formFieldBankAccountNumberLabel;
      case "PaypalMobNumber" :
      case "VenmoMobNumber" :
        return localeString.formFieldPhoneNumberLabel;
      case "PaypalMail" :
      case "InteracEmail" :
        return localeString.emailLabel;
      default:
        return localeString.formFieldBankNameLabel;
    }
  }
}

function getPaymentMethodDataFieldPlaceholder(key, locale, constant) {
  if (key.TAG === "BillingAddress") {
    let tmp = key._0;
    if (typeof tmp === "object") {
      if (tmp.TAG === "FullName") {
        return locale.fullNamePlaceholder;
      } else {
        return locale.countryLabel;
      }
    }
    switch (tmp) {
      case "Email" :
        return locale.formFieldEmailPlaceholder;
      case "PhoneNumber" :
        return locale.formFieldPhoneNumberPlaceholder;
      case "CountryCode" :
      case "PhoneCountryCode" :
        return locale.formFieldCountryCodeRequiredLabel;
      case "AddressLine1" :
        return locale.line1Placeholder;
      case "AddressLine2" :
        return locale.line2Placeholder;
      case "AddressCity" :
        return locale.cityLabel;
      case "AddressState" :
        return locale.stateLabel;
      case "AddressPincode" :
        return locale.postalCodeLabel;
    }
  } else {
    let tmp$1 = key._0;
    if (typeof tmp$1 === "object") {
      return locale.expiryPlaceholder;
    }
    switch (tmp$1) {
      case "CardNumber" :
        return constant.formFieldCardNumberPlaceholder;
      case "CardHolderName" :
        return locale.formFieldCardHoldernamePlaceholder;
      case "CardBrand" :
        return "Misc.";
      case "ACHRoutingNumber" :
        return constant.formFieldACHRoutingNumberPlaceholder;
      case "BacsSortCode" :
        return constant.formFieldSortCodePlaceholder;
      case "ACHAccountNumber" :
      case "BacsAccountNumber" :
        return constant.formFieldAccountNumberPlaceholder;
      case "SepaIban" :
        return constant.formFieldSepaIbanPlaceholder;
      case "SepaBic" :
        return constant.formFieldSepaBicPlaceholder;
      case "ACHBankCity" :
      case "BacsBankCity" :
      case "SepaBankCity" :
        return locale.formFieldBankCityPlaceholder;
      case "SepaCountryCode" :
        return locale.countryLabel;
      case "PixKey" :
        return constant.formFieldPixIdPlaceholder;
      case "PixBankAccountNumber" :
        return constant.formFieldBankAccountNumberPlaceholder;
      case "PaypalMobNumber" :
      case "VenmoMobNumber" :
        return locale.formFieldPhoneNumberPlaceholder;
      case "PaypalMail" :
      case "InteracEmail" :
        return locale.formFieldEmailPlaceholder;
      default:
        return locale.formFieldBankNamePlaceholder;
    }
  }
}

function getPaymentMethodDataFieldMaxLength(key) {
  if (key.TAG === "BillingAddress") {
    return 32;
  }
  let tmp = key._0;
  if (typeof tmp === "object") {
    return 7;
  }
  switch (tmp) {
    case "CardNumber" :
      return 23;
    case "ACHRoutingNumber" :
      return 9;
    case "ACHAccountNumber" :
      return 17;
    case "BacsSortCode" :
      return 6;
    case "BacsAccountNumber" :
      return 18;
    case "SepaIban" :
      return 34;
    case "SepaBic" :
      return 11;
    default:
      return 32;
  }
}

function getPaymentMethodDataFieldCharacterPattern(key) {
  if (key.TAG === "BillingAddress") {
    let tmp = key._0;
    if (typeof tmp === "object") {
      return;
    }
    switch (tmp) {
      case "PhoneNumber" :
        return /^[0-9]{1,12}$/;
      case "PhoneCountryCode" :
        return /^[0-9]{1,3}$/;
      case "AddressPincode" :
        return /^([0-9A-Z]| ){1,10}$/;
      default:
        return;
    }
  } else {
    let tmp$1 = key._0;
    if (typeof tmp$1 === "object") {
      return;
    }
    switch (tmp$1) {
      case "CardNumber" :
        return /^\d{1,18}$/;
      case "CardHolderName" :
        return /^([a-zA-Z]| ){1,32}$/;
      case "ACHRoutingNumber" :
        return /^\d{1,9}$/;
      case "ACHAccountNumber" :
        return /^\d{1,17}$/;
      case "BacsSortCode" :
        return /^\d{1,6}$/;
      case "BacsAccountNumber" :
        return /^\d{1,18}$/;
      case "SepaIban" :
        return /^([A-Z0-9]| ){1,34}$/;
      case "SepaBic" :
        return /^([A-Z0-9]| ){1,11}$/;
      case "PaypalMobNumber" :
        return /^[0-9]{1,12}$/;
      default:
        return;
    }
  }
}

function getPaymentMethodDataFieldInputType(key) {
  if (key.TAG === "BillingAddress") {
    return "text";
  }
  let tmp = key._0;
  if (typeof tmp === "object") {
    return "tel";
  }
  switch (tmp) {
    case "CardNumber" :
    case "ACHRoutingNumber" :
    case "ACHAccountNumber" :
    case "BacsSortCode" :
    case "BacsAccountNumber" :
    case "PaypalMobNumber" :
    case "VenmoMobNumber" :
      return "tel";
    case "PaypalMail" :
    case "InteracEmail" :
      return "email";
    default:
      return "text";
  }
}

function getPayoutImageSource(payoutStatus) {
  switch (payoutStatus) {
    case "Success" :
      return "https://live.hyperswitch.io/payment-link-assets/success.png";
    case "Initiated" :
    case "Pending" :
    case "RequiresFulfillment" :
      return "https://live.hyperswitch.io/payment-link-assets/pending.png";
    default:
      return "https://live.hyperswitch.io/payment-link-assets/failed.png";
  }
}

function getPayoutReadableStatus(payoutStatus, localeString) {
  switch (payoutStatus) {
    case "Success" :
      return localeString.payoutStatusSuccessText;
    case "Initiated" :
    case "Pending" :
    case "RequiresFulfillment" :
      return localeString.payoutStatusPendingText;
    default:
      return localeString.payoutStatusFailedText;
  }
}

function getPayoutStatusString(payoutStatus) {
  switch (payoutStatus) {
    case "Success" :
      return "success";
    case "Failed" :
      return "failed";
    case "Cancelled" :
      return "expired";
    case "Initiated" :
      return "initiated";
    case "Expired" :
      return "cancelled";
    case "Reversed" :
      return "reversed";
    case "Pending" :
      return "pending";
    case "Ineligible" :
      return "ineligible";
    case "RequiresCreation" :
      return "requires_creation";
    case "RequiresConfirmation" :
      return "requires_confirmation";
    case "RequiresPayoutMethodData" :
      return "requires_payout_method_data";
    case "RequiresFulfillment" :
      return "requires_fulfillment";
    case "RequiresVendorAccountCreation" :
      return "requires_vendor_account_creation";
  }
}

function getPayoutStatusMessage(payoutStatus, localeString) {
  switch (payoutStatus) {
    case "Success" :
      return localeString.payoutStatusSuccessMessage;
    case "Initiated" :
    case "Pending" :
    case "RequiresFulfillment" :
      return localeString.payoutStatusPendingMessage;
    default:
      return localeString.payoutStatusFailedMessage;
  }
}

function getPaymentMethodDataErrorString(key, value, localeString) {
  let len = value.length;
  let notEmptyAndComplete = len >= 0 && len === getPaymentMethodDataFieldMaxLength(key);
  if (key.TAG === "BillingAddress") {
    let tmp = key._0;
    if (typeof tmp === "object") {
      if (tmp.TAG === "FullName") {
        return localeString.nameEmptyText(localeString.fullNameLabel);
      } else {
        return localeString.nameEmptyText(localeString.countryLabel);
      }
    }
    switch (tmp) {
      case "Email" :
        if (value.trim().length === 0) {
          return localeString.emailEmptyText;
        } else {
          return localeString.emailInvalidText;
        }
      case "PhoneNumber" :
        return localeString.nameEmptyText(localeString.formFieldPhoneNumberLabel);
      case "CountryCode" :
      case "PhoneCountryCode" :
        return localeString.nameEmptyText(localeString.formFieldCountryCodeRequiredLabel);
      case "AddressLine1" :
        return localeString.line1EmptyText;
      case "AddressLine2" :
        return localeString.line2EmptyText;
      case "AddressCity" :
        return localeString.cityEmptyText;
      case "AddressState" :
        return localeString.stateEmptyText;
      case "AddressPincode" :
        if (value.trim().length === 0) {
          return localeString.postalCodeEmptyText;
        } else {
          return localeString.postalCodeInvalidText;
        }
    }
  } else {
    let tmp$1 = key._0;
    if (typeof tmp$1 === "object") {
      if (notEmptyAndComplete) {
        return localeString.pastExpiryErrorText;
      } else {
        return localeString.inCompleteExpiryErrorText;
      }
    }
    switch (tmp$1) {
      case "CardNumber" :
        return localeString.inValidCardErrorText;
      case "CardHolderName" :
        if (value.trim().length === 0) {
          return localeString.nameEmptyText(localeString.cardHolderName);
        } else {
          return localeString.completeNameEmptyText(localeString.cardHolderName);
        }
      case "ACHRoutingNumber" :
        if (notEmptyAndComplete) {
          return "";
        } else {
          return localeString.formFieldInvalidRoutingNumber;
        }
      case "BacsSortCode" :
        if (value.trim().length === 0) {
          return localeString.nameEmptyText(localeString.sortCodeText);
        } else {
          return localeString.sortCodeInvalidText;
        }
      case "BacsAccountNumber" :
        if (value.trim().length === 0) {
          return localeString.nameEmptyText(localeString.accountNumberText);
        } else {
          return localeString.accountNumberInvalidText;
        }
      case "SepaIban" :
        if (value.trim().length === 0) {
          return localeString.ibanEmptyText;
        } else {
          return localeString.ibanInvalidText;
        }
      case "PaypalMobNumber" :
      case "VenmoMobNumber" :
        return localeString.nameEmptyText(localeString.formFieldPhoneNumberLabel);
      case "InteracEmail" :
        if (value.trim().length === 0) {
          return localeString.emailEmptyText;
        } else {
          return localeString.emailInvalidText;
        }
      default:
        return "";
    }
  }
}

function getPaymentMethodIcon(paymentMethod) {
  switch (paymentMethod) {
    case "Card" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "default-card",
        size: 20
      });
    case "BankRedirect" :
    case "BankTransfer" :
      break;
    case "Wallet" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "wallet-generic-line",
        size: 20
      });
  }
  return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
    name: "bank",
    size: 20
  });
}

function getBankTransferIcon(bankTransfer) {
  switch (bankTransfer) {
    case "ACH" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "ach_bank_transfer",
        size: 20
      });
    case "Pix" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "wallet-pix",
        size: 20
      });
    case "Bacs" :
    case "Sepa" :
      break;
  }
  return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
    name: "bank",
    size: 20
  });
}

function getWalletIcon(wallet) {
  if (wallet === "Paypal") {
    return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
      name: "wallet-paypal",
      size: 20
    });
  } else {
    return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
      name: "wallet-venmo",
      size: 20
    });
  }
}

function getBankRedirectIcon(bankRedirect) {
  return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
    name: "interac",
    size: 20
  });
}

function getPaymentMethodTypeIcon(paymentMethodType) {
  switch (paymentMethodType.TAG) {
    case "Card" :
      return getPaymentMethodIcon("Card");
    case "BankRedirect" :
      return getBankRedirectIcon(paymentMethodType._0);
    case "BankTransfer" :
      return getBankTransferIcon(paymentMethodType._0);
    case "Wallet" :
      return getWalletIcon(paymentMethodType._0);
  }
}

let defaultFormDataDict = {};

let defaultValidityDict = {};

let defaultAvailablePaymentMethods = [];

let defaultAvailablePaymentMethodTypes = [];

function defaultPmt(pmOpt) {
  let pm = pmOpt !== undefined ? pmOpt : "Card";
  switch (pm) {
    case "Card" :
      return {
        TAG: "Card",
        _0: "Debit"
      };
    case "BankRedirect" :
      return {
        TAG: "BankRedirect",
        _0: "Interac"
      };
    case "BankTransfer" :
      return {
        TAG: "BankTransfer",
        _0: "ACH"
      };
    case "Wallet" :
      return {
        TAG: "Wallet",
        _0: "Paypal"
      };
  }
}

let defaultCardFields = [
  {
    pmdMap: "payout_method_data.card.card_number",
    displayName: "user_card_number",
    fieldType: "CardNumber",
    value: undefined
  },
  {
    pmdMap: "payout_method_data.card.expiry_month",
    displayName: "user_card_exp_month",
    fieldType: {
      TAG: "CardExpDate",
      _0: "CardExpMonth"
    },
    value: undefined
  },
  {
    pmdMap: "payout_method_data.card.expiry_year",
    displayName: "user_card_exp_year",
    fieldType: {
      TAG: "CardExpDate",
      _0: "CardExpYear"
    },
    value: undefined
  }
];

let defaultAchFields = [
  {
    pmdMap: "payout_method_data.ach.bank_routing_number",
    displayName: "user_routing_number",
    fieldType: "ACHRoutingNumber",
    value: undefined
  },
  {
    pmdMap: "payout_method_data.ach.bank_account_number",
    displayName: "user_bank_account_number",
    fieldType: "ACHAccountNumber",
    value: undefined
  }
];

let defaultBacsFields = [
  {
    pmdMap: "payout_method_data.bank.bank_sort_code",
    displayName: "user_sort_code",
    fieldType: "BacsSortCode",
    value: undefined
  },
  {
    pmdMap: "payout_method_data.bank.bank_account_number",
    displayName: "user_bank_account_number",
    fieldType: "BacsAccountNumber",
    value: undefined
  }
];

let defaultPixTransferFields = [
  {
    pmdMap: "payout_method_data.bank.bank_account_number",
    displayName: "user_bank_account_number",
    fieldType: "PixBankAccountNumber",
    value: undefined
  },
  {
    pmdMap: "payout_method_data.bank.pix_key",
    displayName: "user_pix_key",
    fieldType: "PixKey",
    value: undefined
  }
];

let defaultSepaFields = [{
    pmdMap: "payout_method_data.bank.iban",
    displayName: "user_iban",
    fieldType: "SepaIban",
    value: undefined
  }];

let defaultPaypalFields = [{
    pmdMap: "payout_method_data.wallet.paypal.telephone_number",
    displayName: "user_phone_number",
    fieldType: "PaypalMobNumber",
    value: undefined
  }];

let defaultInteracFields = [{
    pmdMap: "payout_method_data.bank_redirect.interac.email",
    displayName: "email",
    fieldType: "InteracEmail",
    value: undefined
  }];

function defaultDynamicPmdFields(pmtOpt) {
  let pmt = pmtOpt !== undefined ? pmtOpt : defaultPmt(undefined);
  switch (pmt.TAG) {
    case "Card" :
      return defaultCardFields;
    case "BankRedirect" :
      return defaultInteracFields;
    case "BankTransfer" :
      switch (pmt._0) {
        case "ACH" :
          return defaultAchFields;
        case "Bacs" :
          return defaultBacsFields;
        case "Pix" :
          return defaultPixTransferFields;
        case "Sepa" :
          return defaultSepaFields;
      }
    case "Wallet" :
      if (pmt._0 === "Paypal") {
        return defaultPaypalFields;
      } else {
        return [];
      }
  }
}

function defaultPayoutDynamicFields(pmtOpt) {
  let pmt = pmtOpt !== undefined ? pmtOpt : defaultPmt(undefined);
  return {
    address: undefined,
    payoutMethodData: defaultDynamicPmdFields(pmt)
  };
}

function defaultView(layout) {
  if (layout === "Journey") {
    return {
      TAG: "Journey",
      _0: "SelectPM"
    };
  } else {
    return {
      TAG: "Tabs",
      _0: "DetailsForm"
    };
  }
}

let defaultAmount = "0.01";

let defaultCurrency = "EUR";

let defaultEnabledPaymentMethods = [
  {
    TAG: "Card",
    _0: "Credit"
  },
  {
    TAG: "Card",
    _0: "Debit"
  },
  {
    TAG: "BankTransfer",
    _0: "ACH"
  },
  {
    TAG: "BankTransfer",
    _0: "Bacs"
  },
  {
    TAG: "BankTransfer",
    _0: "Sepa"
  },
  {
    TAG: "Wallet",
    _0: "Paypal"
  }
];

let defaultEnabledPaymentMethodsWithDynamicFields = [
  {
    TAG: "Card",
    _0: [
      "Credit",
      defaultPayoutDynamicFields({
        TAG: "Card",
        _0: "Credit"
      })
    ]
  },
  {
    TAG: "Card",
    _0: [
      "Debit",
      defaultPayoutDynamicFields({
        TAG: "Card",
        _0: "Debit"
      })
    ]
  },
  {
    TAG: "BankTransfer",
    _0: [
      "ACH",
      defaultPayoutDynamicFields({
        TAG: "BankTransfer",
        _0: "ACH"
      })
    ]
  },
  {
    TAG: "BankTransfer",
    _0: [
      "Bacs",
      defaultPayoutDynamicFields({
        TAG: "BankTransfer",
        _0: "Bacs"
      })
    ]
  },
  {
    TAG: "BankTransfer",
    _0: [
      "Sepa",
      defaultPayoutDynamicFields({
        TAG: "BankTransfer",
        _0: "Sepa"
      })
    ]
  },
  {
    TAG: "Wallet",
    _0: [
      "Paypal",
      defaultPayoutDynamicFields({
        TAG: "Wallet",
        _0: "Paypal"
      })
    ]
  }
];

let defaultPaymentMethodCollectOptions = {
  enabledPaymentMethods: defaultEnabledPaymentMethods,
  enabledPaymentMethodsWithDynamicFields: defaultEnabledPaymentMethodsWithDynamicFields,
  linkId: "",
  payoutId: "",
  customerId: "",
  theme: "#1A1A1A",
  collectorName: "HyperSwitch",
  logo: "",
  returnUrl: undefined,
  amount: defaultAmount,
  currency: defaultCurrency,
  flow: "PayoutLinkInitiate",
  sessionExpiry: "",
  formLayout: "Tabs"
};

let defaultStatusInfo_message = EnglishLocale$OrcaPaymentPage.localeStrings.payoutStatusSuccessMessage;

let defaultStatusInfo = {
  status: "Success",
  payoutId: "",
  message: defaultStatusInfo_message,
  code: undefined,
  errorMessage: undefined,
  reason: undefined
};

function itemToObjMapper(dict) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
    "enabledPaymentMethods",
    "linkId",
    "payoutId",
    "customerId",
    "theme",
    "collectorName",
    "logo",
    "returnUrl",
    "amount",
    "currency",
    "flow",
    "sessionExpiry",
    "formLayout"
  ], dict, "options");
  let json = dict["enabledPaymentMethods"];
  let match = json !== undefined ? PaymentMethodCollectTypes$OrcaPaymentPage.decodePaymentMethodTypeArray(json, defaultDynamicPmdFields) : [
      defaultEnabledPaymentMethods,
      defaultEnabledPaymentMethodsWithDynamicFields
    ];
  return {
    enabledPaymentMethods: match[0],
    enabledPaymentMethodsWithDynamicFields: match[1],
    linkId: Utils$OrcaPaymentPage.getString(dict, "linkId", ""),
    payoutId: Utils$OrcaPaymentPage.getString(dict, "payoutId", ""),
    customerId: Utils$OrcaPaymentPage.getString(dict, "customerId", ""),
    theme: Utils$OrcaPaymentPage.getString(dict, "theme", ""),
    collectorName: Utils$OrcaPaymentPage.getString(dict, "collectorName", ""),
    logo: Utils$OrcaPaymentPage.getString(dict, "logo", ""),
    returnUrl: Core__Option.flatMap(dict["returnUrl"], Core__JSON.Decode.string),
    amount: PaymentMethodCollectTypes$OrcaPaymentPage.decodeAmount(dict, defaultAmount),
    currency: Utils$OrcaPaymentPage.getString(dict, "currency", defaultCurrency),
    flow: PaymentMethodCollectTypes$OrcaPaymentPage.decodeFlow(dict, "PayoutLinkInitiate"),
    sessionExpiry: Utils$OrcaPaymentPage.getString(dict, "sessionExpiry", ""),
    formLayout: PaymentMethodCollectTypes$OrcaPaymentPage.decodeFormLayout(dict, "Tabs")
  };
}

function calculateValidity(key, value, cardBrand, defaultOpt) {
  let $$default = defaultOpt !== undefined ? Primitive_option.valFromOption(defaultOpt) : undefined;
  let exit = 0;
  if (key.TAG === "BillingAddress") {
    let tmp = key._0;
    exit = typeof tmp !== "object" && tmp === "Email" ? 1 : 2;
  } else {
    let tmp$1 = key._0;
    if (typeof tmp$1 === "object") {
      if (value.length > 0 && CardUtils$OrcaPaymentPage.getExpiryValidity(value)) {
        return true;
      } else if (value.length === 0) {
        return $$default;
      } else {
        return false;
      }
    }
    switch (tmp$1) {
      case "CardNumber" :
        if (CardUtils$OrcaPaymentPage.cardNumberInRange(value, cardBrand).includes(true) && CardUtils$OrcaPaymentPage.calculateLuhn(value)) {
          return true;
        } else if (value.length === 0) {
          return $$default;
        } else {
          return false;
        }
      case "CardHolderName" :
        if (value.trim().includes(" ")) {
          return true;
        } else if (value.length === 0) {
          return $$default;
        } else {
          return false;
        }
      case "ACHRoutingNumber" :
        if (value.length !== 9) {
          return false;
        }
        let match = Core__Int.fromString(value.charAt(0), undefined);
        let match$1 = Core__Int.fromString(value.charAt(3), undefined);
        let match$2 = Core__Int.fromString(value.charAt(6), undefined);
        let p1 = match !== undefined && match$1 !== undefined && match$2 !== undefined ? 3 * ((match + match$1 | 0) + match$2 | 0) | 0 : undefined;
        let match$3 = Core__Int.fromString(value.charAt(1), undefined);
        let match$4 = Core__Int.fromString(value.charAt(4), undefined);
        let match$5 = Core__Int.fromString(value.charAt(7), undefined);
        let p2 = match$3 !== undefined && match$4 !== undefined && match$5 !== undefined ? 7 * ((match$3 + match$4 | 0) + match$5 | 0) | 0 : undefined;
        let match$6 = Core__Int.fromString(value.charAt(2), undefined);
        let match$7 = Core__Int.fromString(value.charAt(5), undefined);
        let match$8 = Core__Int.fromString(value.charAt(8), undefined);
        let p3 = match$6 !== undefined && match$7 !== undefined && match$8 !== undefined ? (match$6 + match$7 | 0) + match$8 | 0 : undefined;
        if (p1 !== undefined && p2 !== undefined && p3 !== undefined) {
          return ((p1 + p2 | 0) + p3 | 0) % 10 === 0;
        } else {
          return false;
        }
      case "SepaIban" :
        return value.length > 13 && value.length < 34;
      case "SepaBic" :
        return true;
      case "PaypalMail" :
      case "InteracEmail" :
        exit = 1;
        break;
      default:
        exit = 2;
    }
  }
  switch (exit) {
    case 1 :
      if (PaymentMethodCollectTypes$OrcaPaymentPage.emailValidationRegex.test(value)) {
        return true;
      } else if (value.length === 0) {
        return $$default;
      } else {
        return false;
      }
    case 2 :
      if (value.length > 0) {
        return true;
      } else {
        return false;
      }
  }
}

function checkValidity(keys, fieldValidityDict, defaultValidityOpt) {
  let defaultValidity = defaultValidityOpt !== undefined ? defaultValidityOpt : true;
  return Core__Array.reduce(keys, true, (acc, key) => {
    let validity = fieldValidityDict[key];
    if (validity !== undefined) {
      if (acc) {
        return Core__Option.getOr(Primitive_option.valFromOption(validity), defaultValidity);
      } else {
        return false;
      }
    } else {
      return defaultValidity;
    }
  });
}

function processPaymentMethodDataFields(dynamicFieldsInfo, paymentMethodDataDict, fieldValidityDict) {
  let match = Core__Array.reduce(dynamicFieldsInfo, [
    [],
    []
  ], (param, dynamicFieldInfo) => {
    let keys = param[1];
    let dataArr = param[0];
    let match = dynamicFieldInfo.fieldType;
    if (typeof match !== "object") {
      let key = {
        TAG: "PayoutMethodData",
        _0: dynamicFieldInfo.fieldType
      };
      let info = {
        TAG: "PayoutMethodData",
        _0: dynamicFieldInfo
      };
      let fieldKey = getPaymentMethodDataFieldKey(key);
      Core__Option.map(paymentMethodDataDict[fieldKey], value => {
        dataArr.push([
          info,
          value.trim()
        ]);
      });
      keys.push(fieldKey);
      return [
        dataArr,
        keys
      ];
    }
    if (match._0 === "CardExpMonth") {
      let info$1 = {
        TAG: "PayoutMethodData",
        _0: dynamicFieldInfo
      };
      let fieldKey$1 = getPaymentMethodDataFieldKey({
        TAG: "PayoutMethodData",
        _0: {
          TAG: "CardExpDate",
          _0: "CardExpMonth"
        }
      });
      Core__Option.map(paymentMethodDataDict[fieldKey$1], value => Core__Option.map(value.split("/")[0], month => {
        dataArr.push([
          info$1,
          month.trim()
        ]);
      }));
      keys.push(fieldKey$1);
      return [
        dataArr,
        keys
      ];
    }
    let info$2 = {
      TAG: "PayoutMethodData",
      _0: dynamicFieldInfo
    };
    let fieldKey$2 = getPaymentMethodDataFieldKey({
      TAG: "PayoutMethodData",
      _0: {
        TAG: "CardExpDate",
        _0: "CardExpMonth"
      }
    });
    Core__Option.map(paymentMethodDataDict[fieldKey$2], value => Core__Option.map(value.split("/")[1], year => {
      dataArr.push([
        info$2,
        `20` + year.trim()
      ]);
    }));
    keys.push(fieldKey$2);
    return [
      dataArr,
      keys
    ];
  });
  if (checkValidity(match[1], fieldValidityDict, false)) {
    return match[0];
  }
}

function processAddressFields(dynamicFieldsInfo, paymentMethodDataDict, fieldValidityDict) {
  let match = Core__Array.reduce(dynamicFieldsInfo, [
    [],
    []
  ], (param, dynamicFieldInfo) => {
    let keys = param[1];
    let dataArr = param[0];
    let match = dynamicFieldInfo.fieldType;
    if (typeof match === "object" && match.TAG === "FullName") {
      if (match._0 === "FirstName") {
        let info = {
          TAG: "BillingAddress",
          _0: dynamicFieldInfo
        };
        let fieldKey = getPaymentMethodDataFieldKey({
          TAG: "BillingAddress",
          _0: {
            TAG: "FullName",
            _0: "FirstName"
          }
        });
        Core__Option.map(paymentMethodDataDict[fieldKey], value => Core__Option.map(value.split(" ")[0], firstName => {
          dataArr.push([
            info,
            firstName
          ]);
        }));
        keys.push(fieldKey);
        return [
          dataArr,
          keys
        ];
      }
      let info$1 = {
        TAG: "BillingAddress",
        _0: dynamicFieldInfo
      };
      let fieldKey$1 = getPaymentMethodDataFieldKey({
        TAG: "BillingAddress",
        _0: {
          TAG: "FullName",
          _0: "FirstName"
        }
      });
      Core__Option.map(paymentMethodDataDict[fieldKey$1], value => {
        let nameSplits = value.split(" ");
        let lastName = nameSplits.slice(1, nameSplits.length).join(" ");
        if (lastName.length > 0) {
          dataArr.push([
            info$1,
            lastName
          ]);
        } else {
          Core__Option.map(nameSplits[0], firstName => {
            dataArr.push([
              info$1,
              firstName
            ]);
          });
        }
      });
      keys.push(fieldKey$1);
      return [
        dataArr,
        keys
      ];
    }
    let key = {
      TAG: "BillingAddress",
      _0: dynamicFieldInfo.fieldType
    };
    let info$2 = {
      TAG: "BillingAddress",
      _0: dynamicFieldInfo
    };
    let fieldKey$2 = getPaymentMethodDataFieldKey(key);
    Core__Option.map(paymentMethodDataDict[fieldKey$2], value => {
      dataArr.push([
        info$2,
        value
      ]);
    });
    keys.push(fieldKey$2);
    return [
      dataArr,
      keys
    ];
  });
  if (checkValidity(match[1], fieldValidityDict, false)) {
    return match[0];
  }
}

function formPaymentMethodData(paymentMethodDataDict, fieldValidityDict, requiredFields) {
  let addressFields = Core__Option.flatMap(requiredFields.address, address => processAddressFields(address, paymentMethodDataDict, fieldValidityDict));
  return Core__Option.flatMap(processPaymentMethodDataFields(requiredFields.payoutMethodData, paymentMethodDataDict, fieldValidityDict), fields => Core__Option.orElse(Core__Option.map(addressFields, address => address.concat(fields)), fields));
}

function formBody(flow, paymentMethodData) {
  let paymentMethodType = paymentMethodData[0];
  let pmdDict = {};
  paymentMethodData[1].forEach(param => {
    let key = param[0]._0.pmdMap;
    let value = param[1];
    let keys = key.split(".");
    let addToDict = (dict, keys) => {
      let len = keys.length;
      if (len !== 1) {
        if (len === 0) {
          return;
        }
        let head = Core__Option.getOr(keys[0], "");
        let nestedDict = Core__Option.getOr(dict[head], {});
        let newNestedDict;
        newNestedDict = typeof nestedDict === "object" && nestedDict !== null && !Array.isArray(nestedDict) ? nestedDict : ({});
        addToDict(newNestedDict, keys.slice(1));
        dict[head] = newNestedDict;
        return;
      }
      let lastKey = keys[0];
      dict[lastKey] = value;
    };
    addToDict(pmdDict, keys);
  });
  let body = [];
  Object.entries(pmdDict).map(param => {
    body.push([
      param[0],
      param[1]
    ]);
  });
  let paymentMethod = getPaymentMethodForPmt(paymentMethodType);
  let body$1;
  body$1 = paymentMethodType.TAG === "BankRedirect" ? body.concat(BrowserSpec$OrcaPaymentPage.broswerInfo()) : body;
  if (flow === "PayoutLinkInitiate") {
    body$1.push([
      "payout_type",
      getPaymentMethodForPayoutsConfirm(paymentMethod)
    ]);
  } else {
    body$1.push([
      "payment_method",
      getPaymentMethod(paymentMethod)
    ]);
    body$1.push([
      "payment_method_type",
      getPaymentMethodType(paymentMethodType)
    ]);
  }
  return body$1;
}

function getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, reqPmt) {
  return Core__Option.map(enabledPaymentMethodsWithDynamicFields.find(pmtr => {
    switch (pmtr.TAG) {
      case "Card" :
        return reqPmt.TAG === "Card";
      case "BankRedirect" :
        return reqPmt.TAG === "BankRedirect";
      case "BankTransfer" :
        switch (pmtr._0[0]) {
          case "ACH" :
            if (reqPmt.TAG === "BankTransfer") {
              return reqPmt._0 === "ACH";
            } else {
              return false;
            }
          case "Bacs" :
            if (reqPmt.TAG === "BankTransfer") {
              return reqPmt._0 === "Bacs";
            } else {
              return false;
            }
          case "Pix" :
            if (reqPmt.TAG === "BankTransfer") {
              return reqPmt._0 === "Pix";
            } else {
              return false;
            }
          case "Sepa" :
            if (reqPmt.TAG === "BankTransfer") {
              return reqPmt._0 === "Sepa";
            } else {
              return false;
            }
        }
      case "Wallet" :
        if (pmtr._0[0] === "Paypal") {
          if (reqPmt.TAG === "Wallet") {
            return reqPmt._0 === "Paypal";
          } else {
            return false;
          }
        } else if (reqPmt.TAG === "Wallet") {
          return reqPmt._0 !== "Paypal";
        } else {
          return false;
        }
    }
  }), pmt => pmt._0[1]);
}

function getDefaultsAndValidity(payoutDynamicFields, supportedCardBrands) {
  return Core__Option.map(Core__Option.map(payoutDynamicFields.address, address => Core__Array.reduce(address, [
    {},
    {}
  ], (param, field) => {
    let validity = param[1];
    let values = param[0];
    let match = field.fieldType;
    let match$1 = field.value;
    let tmp;
    tmp = typeof match !== "object" || match.TAG !== "AddressCountry" || match$1 !== undefined ? field.value : match._0[0];
    return Core__Option.getOr(Core__Option.map(tmp, value => {
      let key = {
        TAG: "BillingAddress",
        _0: field.fieldType
      };
      let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
      let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
      let isValid = calculateValidity(key, value, newCardBrand, undefined);
      let keyStr = getPaymentMethodDataFieldKey(key);
      values[keyStr] = value;
      validity[keyStr] = isValid;
      return [
        values,
        validity
      ];
    }), [
      values,
      validity
    ]);
  })), param => Core__Array.reduce(payoutDynamicFields.payoutMethodData, [
    param[0],
    param[1]
  ], (param, field) => {
    let validity = param[1];
    let values = param[0];
    let value = field.value;
    if (value !== undefined) {
      let key = {
        TAG: "PayoutMethodData",
        _0: field.fieldType
      };
      let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
      let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
      let isValid = calculateValidity(key, value, newCardBrand, undefined);
      let keyStr = getPaymentMethodDataFieldKey(key);
      values[keyStr] = value;
      validity[keyStr] = isValid;
    }
    return [
      values,
      validity
    ];
  }));
}

let defaultOptionsLimitInTabLayout = 2;

let defaultPm = "Card";

let defaultFormLayout = "Tabs";

let defaultJourneyView = "SelectPM";

let defaultTabView = "DetailsForm";

let defaultPaymentMethodCollectFlow = "PayoutLinkInitiate";

export {
  getNestedValue,
  getOrCreateSubDict,
  setNestedValue,
  getPaymentMethodForPmt,
  getPaymentMethod,
  getPaymentMethodForPayoutsConfirm,
  getPaymentMethodType,
  getPaymentMethodLabel,
  getPaymentMethodTypeLabel,
  getPaymentMethodDataFieldKey,
  getPaymentMethodDataFieldLabel,
  getPaymentMethodDataFieldPlaceholder,
  getPaymentMethodDataFieldMaxLength,
  getPaymentMethodDataFieldCharacterPattern,
  getPaymentMethodDataFieldInputType,
  getPayoutImageSource,
  getPayoutReadableStatus,
  getPayoutStatusString,
  getPayoutStatusMessage,
  getPaymentMethodDataErrorString,
  getPaymentMethodIcon,
  getBankTransferIcon,
  getWalletIcon,
  getBankRedirectIcon,
  getPaymentMethodTypeIcon,
  defaultFormDataDict,
  defaultValidityDict,
  defaultOptionsLimitInTabLayout,
  defaultAvailablePaymentMethods,
  defaultAvailablePaymentMethodTypes,
  defaultPm,
  defaultPmt,
  defaultCardFields,
  defaultAchFields,
  defaultBacsFields,
  defaultPixTransferFields,
  defaultSepaFields,
  defaultPaypalFields,
  defaultInteracFields,
  defaultDynamicPmdFields,
  defaultPayoutDynamicFields,
  defaultFormLayout,
  defaultJourneyView,
  defaultTabView,
  defaultView,
  defaultPaymentMethodCollectFlow,
  defaultAmount,
  defaultCurrency,
  defaultEnabledPaymentMethods,
  defaultEnabledPaymentMethodsWithDynamicFields,
  defaultPaymentMethodCollectOptions,
  defaultStatusInfo,
  itemToObjMapper,
  calculateValidity,
  checkValidity,
  processPaymentMethodDataFields,
  processAddressFields,
  formPaymentMethodData,
  formBody,
  getPayoutDynamicFields,
  getDefaultsAndValidity,
}
/* defaultEnabledPaymentMethodsWithDynamicFields Not a pure module */
